import { render, staticRenderFns } from "./ApprovalRequestsRow.vue?vue&type=template&id=3c876bec"
import script from "./ApprovalRequestsRow.vue?vue&type=script&lang=js"
export * from "./ApprovalRequestsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports